import type { UserSettings } from '../shared/contracts';

export type FontSize = UserSettings['fontSize'];

export const FONT_SIZE_STORAGE_KEY = 'mail-panda-font-size';

const fontSizes: readonly FontSize[] = ['small', 'medium', 'large', 'xlarge'];

export function isFontSize(value: string | null): value is FontSize {
  return value !== null && fontSizes.includes(value as FontSize);
}

export function getPreferredFontSize(fallback: FontSize): FontSize {
  try {
    const stored = window.localStorage.getItem(FONT_SIZE_STORAGE_KEY);
    return isFontSize(stored) ? stored : fallback;
  } catch {
    return fallback;
  }
}

export function applyPreferredFontSize(value: FontSize): void {
  document.documentElement.dataset.fontSize = value;
  try {
    window.localStorage.setItem(FONT_SIZE_STORAGE_KEY, value);
  } catch {
    // Storage may be unavailable in private browsing. The current page still updates.
  }
}
